/**
 * Review-item kinds (idc-portal-design v1.1, AIC-179): what the agents raise for the analyst (swtracker.review_items
 * kind). Each has an icon and a full text label; the tone says whose move it is, as Today's review card does. A kind
 * this map doesn't know is shown as its text in the waiting tone, never blank.
 */
import { Icon } from "./Sprites.tsx";
import type { Tone } from "./status.tsx";

export const REVIEW_KINDS: Readonly<Record<string, { label: string; icon: string; tone: Tone }>> = {
  disagreement: { label: "Disagreement", icon: "results", tone: "you" },
  escalation: { label: "Escalation", icon: "alert", tone: "risk" },
  refusal: { label: "Refusal", icon: "off", tone: "risk" },
  anomaly: { label: "Unusual figure", icon: "info", tone: "risk" },
  budget: { label: "Budget", icon: "clock", tone: "wait" },
  custom_question: { label: "Custom question", icon: "mic", tone: "wait" },
  other: { label: "Other", icon: "doc", tone: "wait" },
};

const humanize = (s: string) => s.replace(/_/g, " ").replace(/^./, (c) => c.toUpperCase());

export function reviewKind(kind: string): { label: string; icon: string; tone: Tone } {
  return REVIEW_KINDS[kind] ?? { label: humanize(kind), icon: "info", tone: "wait" };
}

export function KindPill({ kind }: { readonly kind: string }) {
  const k = reviewKind(kind);
  return <span className={`ipd-pill ipd-t--${k.tone}`} data-kind={kind}><Icon name={k.icon} /><span>{k.label}</span></span>;
}
